import React, { useState, useEffect } from "react";
import "./css/visitor-info-popup.css";

export default function VisitorInfoPopup() {
    const [isOpen, setIsOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        fullName: "",
        phoneNumber: "",
        city: "",
        state: "",
        requirement: "",
        description: ""
    });

    useEffect(() => {
        // Show popup after 2 seconds on load
        const timer = setTimeout(() => {
            setIsOpen(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        try {
            console.log("Submitting form data:", formData);
            
            // Send data to Google Apps Script (now using JSON)
            const scriptURL = process.env.REACT_APP_POPUP_FORM_APPSCRIPT_URL;
            if (scriptURL) {
                // Collect recipients from .env
                const recipients = [];
                if (process.env.REACT_APP_POPUP_FORM_RECIPIENT_1) recipients.push(process.env.REACT_APP_POPUP_FORM_RECIPIENT_1);
                if (process.env.REACT_APP_POPUP_FORM_RECIPIENT_2) recipients.push(process.env.REACT_APP_POPUP_FORM_RECIPIENT_2);
                
                // Set a dynamic subject for the email using ONLY env variable prefix
                const subject = process.env.REACT_APP_MAIL_SUBJECT_PREFIX || "New Website Inquiry";
                
                await fetch(scriptURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ...formData,
                        subject: subject,
                        recipients: recipients
                    }),
                    mode: 'no-cors' // Important for Google Apps Script
                });
            } else {
                console.warn("Google Script URL not found in environment variables");
                // Fallback simulation if no URL
                await new Promise(resolve => setTimeout(resolve, 1500));
            }
            
            setIsSubmitted(true);
            
            // Track Facebook Pixel Lead event
            if (window.fbq) {
                window.fbq('track', 'Lead', {
                    content_name: formData.requirement,
                    city: formData.city
                });
            }

            // Mark as seen so it doesn't pop up again
            localStorage.setItem("rupin_visitor_popup_seen", "true");
            
            // Close popup after 3 seconds
            setTimeout(() => {
                setIsOpen(false);
            }, 3000);
            
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setIsOpen(false);
        // Mark as seen so it doesn't pop up again immediately for this session/user
        // localStorage.setItem("rupin_visitor_popup_seen", "true"); 
    };

    if (!isOpen) return null;

    return (
        <div className="visitor-popup-overlay">
            <div className="visitor-popup-container">
                <button className="visitor-popup-close" onClick={handleClose}>&times;</button>
                
                {isSubmitted ? (
                    <div className="visitor-popup-success">
                        <div className="success-icon">✓</div>
                        <h3>Thank You!</h3>
                        <p>We received your details. Our team will contact you shortly.</p>
                    </div>
                ) : (
                    <>
                        <div className="visitor-popup-header">
                            <h2>Get in Touch</h2>
                            <p>Tell us about your requirements</p>
                        </div>
                        
                        <form className="visitor-popup-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Full Name</label>
                                <input 
                                    type="text" 
                                    name="fullName" 
                                    value={formData.fullName} 
                                    onChange={handleChange} 
                                    required 
                                    placeholder="Enter your full name"
                                />
                            </div>

                            <div className="form-group">
                                <label>Phone Number</label>
                                <input 
                                    type="tel" 
                                    name="phoneNumber" 
                                    value={formData.phoneNumber} 
                                    onChange={handleChange} 
                                    required 
                                    placeholder="Enter your phone number"
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-group half">
                                    <label>City</label>
                                    <input 
                                        type="text" 
                                        name="city" 
                                        value={formData.city} 
                                        onChange={handleChange} 
                                        required 
                                        placeholder="City"
                                    />
                                </div>
                                <div className="form-group half">
                                    <label>State</label>
                                    <input 
                                        type="text" 
                                        name="state" 
                                        value={formData.state} 
                                        onChange={handleChange} 
                                        required 
                                        placeholder="State"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Requirement</label>
                                <select 
                                    name="requirement" 
                                    value={formData.requirement} 
                                    onChange={handleChange} 
                                    required
                                >
                                    <option value="" disabled>Select Requirement</option>
                                    <option value="Full Home Automation">Full Home Automation</option>
                                    <option value="Curtain/Blinds Automation">Curtain Automation / Blinds Automation</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea 
                                    name="description" 
                                    value={formData.description} 
                                    onChange={handleChange} 
                                    placeholder="Tell us more about your project..."
                                    rows="3"
                                ></textarea>
                            </div>

                            <button type="submit" className="visitor-popup-submit" disabled={isLoading}>
                                {isLoading ? "Sending..." : "Submit Enquiry"}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
